/** UUID v4 (flessibile su varianti hyphenated). */
const SESSION_ID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isWellFormedSessionId(raw: string | null | undefined): boolean {
  return typeof raw === 'string' && SESSION_ID_RE.test(raw.trim());
}

/**
 * Legge `?session=` dalla pagina pubblica `/vote` (anche con `import.meta.env.BASE_URL`).
 */
export function getVoteSessionIdFromCurrentUrl(): string | null {
  if (typeof window === 'undefined') return null;
  const path = window.location.pathname.replace(/\/+$/, '');
  if (!path.endsWith('/vote')) return null;
  const raw = new URLSearchParams(window.location.search).get('session');
  if (!raw?.trim() || !SESSION_ID_RE.test(raw.trim())) return null;
  return raw.trim();
}

/** URL assoluto per aprire il voto da QR (stesso host e base path dell’app). */
export function buildPublicVoteUrl(sessionId: string): string {
  if (typeof window === 'undefined') return '';
  const origin = window.location.origin;
  const base = import.meta.env.BASE_URL.endsWith('/')
    ? import.meta.env.BASE_URL
    : `${import.meta.env.BASE_URL}/`;
  return new URL(`vote?session=${encodeURIComponent(sessionId)}`, `${origin}${base}`).toString();
}

/** Link partecipante: `?session=` è il nome gara (come in `event_sessions.name`). */
export function buildParticipantJoinUrl(sessionName: string): string {
  if (typeof window === 'undefined') return '';
  const name = sessionName.trim();
  if (!name) return '';
  const origin = window.location.origin;
  const base = import.meta.env.BASE_URL.endsWith('/')
    ? import.meta.env.BASE_URL
    : `${import.meta.env.BASE_URL}/`;
  const params = new URLSearchParams();
  params.set('session', name);
  return new URL(`participant?${params.toString()}`, `${origin}${base}`).toString();
}
